module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/NB产品1.60c073c6.png";